import { commonRequest } from "../../../../services/ApiCall";
import { Helpers } from "../../../../services/Helpers";



export const SlabServices = {
    fetchSlabList: async(data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();
        
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.pageSize);
        queryParams.append('searchKey', data.filters.searchKey || '');
        queryParams.append('sortBy', data.filters.sortBy);
        queryParams.append('sortType', data.filters.sortType || 'desc');
        if (data.filters.filterOptions.length>0) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/subscription/slab/list?${queryParams.toString()}`,{}, Helpers.token());
    },
    slabListToExport: async(data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();
        
        queryParams.append('searchKey', data.filters.searchKey || '');
        queryParams.append('sortBy', data.filters.sortBy);
        queryParams.append('sortType', data.filters.sortType || 'desc');
        if (data.filters.filterOptions.length>0) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/subscription/slab/list/export?${queryParams.toString()}`,{}, Helpers.token());
    },
    addNewSlab: async(data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/subscription/slab`, data, Helpers.token());
    },
    addMultipleSlabs: async(data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/subscription/slab/multiple`, data, Helpers.token());
    },
    updateSlabData: async(data,id)=>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/v2/admin/subscription/slab/${id}`, data, Helpers.token());
    },
    deleteSlab: async(id)=>{
        return await commonRequest("DELETE", `${Helpers.URL()}/api/v2/admin/subscription/slab/${id}`,{}, Helpers.token());
    },
    slabDetailsById: async(id)=>{
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/subscription/slab/${id}`,{}, Helpers.token());
    },
    updateSlabStatus: async(id)=>{
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/subscription/slab/update-status/${id}`,{}, Helpers.token());
    },
    fetchlastSlabDetails: async(categoryId,urbanTypeId )=>{
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/subscription/last/slab-details/${categoryId}/${urbanTypeId}`,{}, Helpers.token());
    },
}